"use client";
import React from "react";
import { Stack } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text, Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";

export type TableFooterProps = {
  btnText?: string;
  text1?: string | React.ReactNode;
};

const PricingFooter = (props: TableFooterProps) => {
  const TextVariant = useTextVariant();
  const { text1, btnText } = props;
  return (
    <Stack mt={6} gap={6}>
      {text1 && (
        <Text
          variant={TextVariant}
          color="text.100"
          fontStyle={"italic"}
          textAlign={"center"}
        >
          <Balancer>{text1}</Balancer>
        </Text>
      )}
      {btnText && (
        <Button
          variant={"ideal"}
          onClick={() => scrollToElement("contact-us", 120)}
          alignSelf={"center"}
          justifySelf={"center"}
          px={6}
        >
          {btnText}
        </Button>
      )}
    </Stack>
  );
};

export default PricingFooter;
